import { Injectable } from '@angular/core';
import {JsonApiService} from "../../../../core/api/json-api.service";
// import {Observable} from 'rxjs/Rx'
import {Observable} from "rxjs/Observable";

@Injectable()
export class ActivitiesService {

  url: string;

  constructor(private jsonApiService: JsonApiService) {
    this.url = '/activities/activities.json';
  }


  getActivities()  {
    return this.jsonApiService.fetch(this.url)

  }

}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/header/activities/activities.service.ts